<template>
  <div id="assignment_certificate_modal" class="uk-modal-full" style="z-index: 999999999" uk-modal>
    <div class="uk-modal-dialog h-100 bggray d-flex flex-column justify-content-between">
      <div class="uk-modal-header d-flex justify-content-end bggray">
        <button class="btn btn-animated btn-success btn-animated-x uk-first-column mr-1" type="button"
                @click="$emit('download')">
          <span class="btn-inner--visible"><i class="uil-file-download"></i> {{ $t("certification.pdf") }}</span>
          <span class="btn-inner--hidden"><i class="uil-cloud-download"></i></span>
        </button>
        <button class="uk-button uk-button-default small uk-modal-close mr-1" type="button">
          <i class="uil-times"></i> {{ $t("general.close") }}
        </button>
      </div>
      <iframe :src="previewLink" style="width: 100%; height: 100%;"></iframe>
      <div class="uk-modal-footer uk-text-right bggray">
        <button class="uk-button uk-button-default small uk-modal-close" type="button">
          <i class="uil-times"></i> {{ $t("general.close") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CertificateModal",
  props: {
    previewLink: { type: String, default: '' },
  },
  emits: ['download'],
};
</script>
